import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ChevronRight, Mail, MapPin, Clock, FileWarning } from "lucide-react";
import { Layout } from "../components/Layout";

const ContactUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Contact the Curator · CurioVault";
    return () => { document.title = "CurioVault"; };
  }, []);

  return (
    <Layout>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10" data-testid="contact-us-page">
        <nav className="flex items-center gap-2 font-mono-cv text-xs text-[#7A6C5D] mb-8" data-testid="breadcrumb">
          <Link to="/" className="hover:text-[#9E4535]">Vault</Link>
          <ChevronRight className="w-3 h-3" />
          <span className="text-[#1A1615]">Contact</span>
        </nav>

        <div className="flex items-center gap-4 mb-8">
          <div className="w-12 h-12 shrink-0 rounded-full border-2 border-[#C5A059] flex items-center justify-center text-[#9E4535]">
            <Mail className="w-6 h-6" />
          </div>
          <h1 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1A1615] leading-tight">
            Contact the Curator
          </h1>
        </div>

        <div className="bg-white border border-[#D8CEB9] rounded-sm p-7 sm:p-9 space-y-5">
          <p className="font-serif-display text-xl text-[#9E4535] italic">Correspondence is welcomed.</p>
          <p className="font-body text-base sm:text-lg text-[#2E282A] leading-[1.85]">
            Whether you have spotted an error, wish to suggest a curiosity for inclusion, or
            wish to discuss licensing, please write to us.
          </p>

          <div className="pt-2 space-y-4 border-t border-[#EAE2D2]">
            <div className="flex items-start gap-3">
              <Mail className="w-4 h-4 text-[#C5A059] mt-1 shrink-0" />
              <div>
                <p className="caption-label mb-1">Email</p>
                <a href="mailto:curator@curiovault.co" data-testid="contact-curator-email" className="font-ui text-sm text-[#9E4535] hover:underline block">curator@curiovault.co</a>
                <p className="font-body text-sm text-[#4A4036] mt-0.5">
                  Or <a href="mailto:contact@curiovault.co" data-testid="contact-general-email" className="text-[#9E4535] hover:underline">contact@curiovault.co</a> (for general enquiries)
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <MapPin className="w-4 h-4 text-[#C5A059] mt-1 shrink-0" />
              <div>
                <p className="caption-label mb-1">Location</p>
                <p className="font-body text-sm text-[#4A4036]">London, England</p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <Clock className="w-4 h-4 text-[#C5A059] mt-1 shrink-0" />
              <div>
                <p className="caption-label mb-1">Response time</p>
                <p className="font-body text-sm text-[#4A4036]">We aim to reply within 48 hours.</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 bg-[#FDF8ED] border border-[#E4D3A8] rounded-sm p-6">
          <div className="flex items-start gap-3">
            <FileWarning className="w-4 h-4 text-[#B08A42] mt-0.5 shrink-0" />
            <div>
              <p className="caption-label !text-[#B08A42] mb-1">For corrections</p>
              <p className="font-body text-sm text-[#4A4036] leading-relaxed">
                Please include the curio title and your source. We verify all corrections.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ContactUs;
